"use strict";
import {types} from "Subschema";
const substitute = types.SubstituteMixin;

export default function minlength$config(options) {
    if (!options.length){
        throw new Error('Missing required length for maxlength validator');

    }

    options = {
        type: 'maxlength',
        message: `Maximum of ${options.length} charecters`,
        ...options
    };
    const msg = substitute(options.message);
    return function minlength(val, vm) {
        if (val && val.length >= options.length) {
            const data = vm ? {...vm.getValue(), options} : {options};
            return {
                level: options.level,
                message: msg.format(data),
                length: val.length,
                type: options.type
            }
        }
    }

};


/** WEBPACK FOOTER **
 ** ./src/validators/maxlength.js
 **/